/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Waitinglistplace2Inputs */

const en__field_waitinglistplace2 = /** @type {(inputs: _Field_Waitinglistplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting List Number`)
};

const de__field_waitinglistplace2 = /** @type {(inputs: _Field_Waitinglistplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wartelistenplatz`)
};

/**
* | output |
* | --- |
* | "Waiting List Number" |
*
* @param {_Field_Waitinglistplace2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_waitinglistplace2 = /** @type {((inputs?: _Field_Waitinglistplace2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Waitinglistplace2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_waitinglistplace2(inputs)
	return de__field_waitinglistplace2(inputs)
});
export { _field_waitinglistplace2 as "_field_waitingListPlace" }